var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('NavBar'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }